export default __webpack_public_path__ + "static/media/twitter_icon.6e932d40.png";